export default __webpack_public_path__ + "static/media/Main-Layout-Header-Image-Landscape-Mobile.6e82c6f5.png";